import React from 'react'
import styles from './Header.module.css'

interface WishlistIconProps {
  onClick: () => void
}

const WishlistIcon: React.FC<WishlistIconProps> = ({ onClick }) => {
  return (
    <button className={styles.wishlistAction} onClick={onClick} aria-label="Список бажань">
      <div className={styles.wishlistContainer}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3084_16580)">
            <path
              d="M3.05359 11.0113L8.18778 16.4222C9.1736 17.4611 10.829 17.4611 11.8148 16.4222L16.949 11.0113C18.7965 9.06428 18.7965 5.90748 16.949 3.96042C15.1015 2.01336 12.1061 2.01336 10.2586 3.96042C10.1187 4.10783 9.88386 4.10783 9.74398 3.96042C7.89648 2.01336 4.90109 2.01336 3.05359 3.96042C1.20609 5.90748 1.20609 9.06428 3.05359 11.0113Z"
              fill="#FF7000"
              stroke="#FF7000"
              strokeWidth="1.5"
            />
          </g>
          <defs>
            <clipPath id="clip0_3084_16580">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </button>
  )
}

export default WishlistIcon
